import en from './en';
import zhTW from './zh-TW';

export const translations = {
  en,
  'zh-TW': zhTW
};

export const languages = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸' },
  { code: 'zh-TW', name: 'Chinese (Traditional)', nativeName: '繁體中文', flag: '🇹🇼' }
];

export default translations;

